import { useSearchParams } from 'react-router-dom'
import { PageChrome, ROUTES } from '@/components/gg/chrome'
import { Settings, SETTINGS_TABS, settingsTab } from '@/pages/Settings'

/**
 * Settings (/app/settings): account and preferences only (Brian's
 * after/profile.html v1). Opened from the initials on the phone and the
 * account card on desktop. A row opens its detail (?tab=account, plan, seeds,
 * voice, newsletter, emma), which comes back to Settings.
 */
export function SettingsPage() {
  const [params] = useSearchParams()
  const tab = settingsTab(params.get('tab'))
  const label = tab ? SETTINGS_TABS.find((t) => t.id === tab)?.label ?? 'Settings' : 'Settings'
  return (
    <>
      {tab
        ? <PageChrome title={label} navKey="settings" group="Settings" back={{ to: ROUTES.settings, label: 'Settings' }} />
        : <PageChrome title="Settings" navKey="settings" back />}
      <Settings />
    </>
  )
}
